export const viewCheckoutPageEvent = () => ({
  type: 'Views checkout page',
});

export const duplicateEmailEntered = errors => ({
  type: 'Email already in use error',
  data: { errors },
});

export const checkoutButtonClicked = () => ({
  type: 'Checkout Button Clicked',
});
